export const ICON_FILL_COLOR = '#424242';
export const ICON_FILL_COLOR_SELECTED = '#7C6BFF';
export const ICON_FILL_COLOR_VISITED = '#737373';
